export default "__VITE_ASSET__BzIzDw0J__"